import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { languages } from '../lib';
import { FaGlobe } from 'react-icons/fa';

// Styled-components
const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const DropdownButton = styled.button`
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  font-size: 16px;
  color: #363535;
  font-weight: 500;
  margin-right: 25px;
  transition: color 0.3s;
  &:hover {
    color: #b19961;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px;
  }
`;

const LanguageIcon = styled(FaGlobe)`
  margin-right: 10px;
`;

const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;

  @media (max-width: 768px) {
    max-height: 150px;
  }
`;

const DropdownItem = styled.li`
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.active ? '#ec1c24 !important' : '#363535'};
  &:hover {
    color: #b19961;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px;
    color: #363535;
  }
`;

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(languages[0].value);
  const { i18n } = useTranslation();

  const languageList = languages;
  const toggleDropdown = () => setIsOpen(!isOpen);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang.code);
    setSelectedOption(lang.value);
    setIsOpen(false);
  };

  return (
    <DropdownContainer>
      <DropdownButton onClick={toggleDropdown}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LanguageIcon />
          {selectedOption}
        </div>
      </DropdownButton>
      {isOpen && (
        <DropdownList>
          {languageList.map((lang, index) => (
            <DropdownItem key={index} active={selectedOption === lang.value} onClick={() => changeLanguage(lang)}>
              {lang.value}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

export default LanguageSelector;
